// extracted by mini-css-extract-plugin
module.exports = {"scroller":"auto-scroller_scroller__BfZB1","scroll":"auto-scroller_scroll__i291G"};